import { motion } from 'framer-motion';

/**
 * Modern, minimalist top navigation bar.
 * Uses a clean "glass pill" design favored in high-end UI.
 */
const Navbar = () => {
  const scrollToPositions = () => {
    document.getElementById('positions-grid')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="flex justify-between items-center mb-20">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full flex justify-between items-center bg-black/40 backdrop-blur-xl border border-white/10 shadow-[0_8px_30px_rgba(212,175,55,0.08)] rounded-full pl-3 pr-4 py-3"
      >
        {/* Logo Section */}
        <div className="flex items-center gap-3 pl-4">
          <div className="w-10 h-10    flex items-center justify-center shadow-inner overflow-hidden  ">
            <img 
              src={process.env.PUBLIC_URL + '/club.png'} 
              alt="Logo" 
              className="w-full h-full object-contain "
              onError={(e) => { 
                e.target.style.display = 'none'; 
                e.target.parentElement.innerHTML = '<span class="text-white font-bold text-lg">L</span>'; 
              }}
            />
          </div>
          <div className="flex flex-col justify-center">
            <span className="text-xl font-extrabold text-white tracking-tight uppercase leading-none">
              Leo Club Of SLIIT
            </span>
            <span className="text-[10px] font-bold text-[#D4AF37] uppercase tracking-[0.2em] mt-1">
              Legacy Continuous
            </span>
          </div>
        </div>

        {/* Action Button */}
        <button
          onClick={scrollToPositions}
          className="bg-[#D4AF37] text-black px-6 py-2.5 rounded-full text-sm font-bold shadow-md hover:bg-[#FFD700] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
        >
          Explore Roles
        </button>
      </motion.div>
    </nav>
  );
};

export default Navbar;
